<script lang="ts">
  let {
    stream,
    video = $bindable<HTMLVideoElement | null>(null),
    fit = 'contain',
  }: { stream: MediaStream | null; video?: HTMLVideoElement | null; fit?: 'contain' | 'cover' } = $props();

  $effect(() => {
    if (!video) return;
    if (video.srcObject !== stream) {
      video.srcObject = stream;
      if (stream) void video.play().catch(() => undefined);
    }
  });
</script>

<!-- Muted: return audio is played separately with its own volume bus. -->
<video bind:this={video} autoplay playsinline muted disablepictureinpicture style:object-fit={fit}></video>

<style>
  video { width: 100%; height: 100%; display: block; background: #000; }
</style>
